var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 272.465,
    height: 60,
    viewBox: "0 0 272.465 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD569\\uCE58\\uAE30 231",
    d: "M234.97 60h-12.5V.008h47.494v10h-35v15h32.5V35h-32.5v15h37.495v10zm-39.995 0V15.006l-20 15v-15l-20 15v-15l20-15v15l20-15h12.5V60zm-89.988 0-12-20H77.49v20h-12.5V.008h30a19.992 19.992 0 0 1 9.15 37.77L117.485 60zM77.49 27.5h17.5a7.5 7.5 0 1 0 0-15h-17.5zM0 60V.008h30A20 20 0 1 1 30 40H12.5v20zm12.5-32.5H30a7.5 7.5 0 1 0 0-15H12.5zm117.73 32.251V0h12.245v59.755z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesLogo2);
export default __webpack_public_path__ + "static/media/features-logo-2.a02baa63d6b3ae13c9dd8a28b613ca18.svg";
export { ForwardRef as ReactComponent };